export default "/images/card2.jpg?e98f6098f4812bdc47e7e91e07d163e3";